<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <ng-container *ngIf="productRetrievalError">
    <h1 class="ta-center">Product Not Found</h1>
    <p class="ta-center">Sorry, we couldn't find that product.</p>

    <p class="ta-center">
      Please try refreshing the page, check the URL, or try again later if that
      doesn't work.
    </p>

    <p class="ta-center">
      Please <a routerLink="/contact-us/form">contact us</a> if you need
      assistance.
    </p>
  </ng-container>
  <ng-container *ngIf="!productRetrievalError">
    <section>
      <div class="content-wrapper">
        <div class="pas-product-banner-wrapper">
          <div
            class="pas-product-banner"
            [class.pas-prouct-image-banner]="pageData.image"
            [class.pas-prouct-video-banner]="
              !pageData.image && pageData.video_id
            "
          >
            <h1>Protect and save</h1>
            <div class="separator"></div>
            <div class="pas-banner-content">
              <h2>{{ pageData.name }}</h2>
              <div class="logo-button-wrapper">
                <div class="contains-logo">
                  <img
                    *ngIf="pageData.image && pageData.hero_type === 'image'"
                    [src]="pageData.image.data.attributes.url"
                  />
                  <iframe
                    *ngIf="pageData.video_id && pageData.hero_type === 'video'"
                    [src]="youtubeUrl()"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </div>

                <div>
                  <p>{{ pageData.description }}</p>
                  <a
                    *ngIf="pageData.get_quote_link && pageData.get_quote_link"
                    [attr.href]="
                      userService.addUserIDToURL(pageData.get_quote_link)
                    "
                    [attr.target]="pageData.get_quote_link"
                    ><button class="button">
                      {{ pageData.get_quote_text }}
                    </button></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="content-wrapper">
      <div
        class="pas-product-tabs-container"
        *ngIf="pageData.tabs && pageData.tabs.length >= 1"
      >
        <app-generic-tabs
          [tabData]="tabData"
          (selectedTab)="onTabChanged($event)"
        ></app-generic-tabs>
      </div>
    </div>
    <section>
      <div class="content-wrapper">
        <div class="pas-product-tab-pane">
          <app-render-markdown [content]="tabContent"></app-render-markdown>
        </div>
        <!-- richtextfield -->
      </div>
    </section>
  </ng-container>
</div>
